import { isServerRendering, getUA } from '@kso/util';

var UA = isServerRendering() ? {} : getUA(navigator.userAgent);

export { UA as default };
